import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import DynamicTabsDrawer from "../../../components/DynamicTabDrawer";
import NavigationDrawer from "../../../components/NavigationDrawer";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import AllCompanyUsers from "./AllCompanyUsers";
import AllRolls from "./AllRolls";
import Profile from "./Profile";

const tabs = [
  { label: "companyDetails", value: "company_details" },
  { label: "createRoles", value: "company_rolls" },
  { label: "createUsers", value: "company_users" },
];

const CompanySettings = () => {
  const dispatch = useDispatch();
  // Redux states
  const activeTab = useSelector((state) => state.activeTab.tabs);

  // Function

  const handleChangeTab = (tab) => {
    dispatch(setActiveTab({ ...activeTab, compnay_settings: tab }));
  };
  return (
    <NavigationDrawer>
      <Grid container spacing={1}>
        <Grid item xs={12} md={2.3}>
          <DynamicTabsDrawer
            primaryHeading={"settings"}
            tabs={tabs}
            activeTab={activeTab.compnay_settings}
            handleChangeTab={handleChangeTab}
          />
        </Grid>
        <Grid item xs={12} md={9.7}>
          {activeTab.compnay_settings === "company_details" ? (
            <Profile />
          ) : activeTab.compnay_settings === "company_rolls" ? (
            <AllRolls />
          ) : (
            <AllCompanyUsers />
          )}
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
};

export default CompanySettings;
